module.exports = __webpack_public_path__ + "static/media/Boton_FastMag.f08167d9.webp";